import { PII_KEYS } from './constants';

const isEmpty = (value) =>
    value === undefined || value === null || (typeof value === 'number' && Number.isNaN(value));

const isNested = (value) =>
    typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date);

/**
 * Flat, PII-free copy of `properties`: empty values and nested objects are left out rather than
 * sent, since Mixpanel can't filter on either. String length is left to the SDK.
 */
export const sanitize = (properties = {}) => {
    const clean = {};

    Object.entries(properties).forEach(([key, value]) => {
        if (PII_KEYS.has(key) || isEmpty(value) || isNested(value)) return;

        clean[key] = value;
    });

    return clean;
};
